import { Outlet } from '@tanstack/react-router';
import { LayoutContext, useDesktopMediaQuery } from '../lib/layout';
import { useLive } from '../lib/live';
import { BottomTabs } from './BottomTabs';
import { Rail } from './Rail';

/**
 * The signed-in app. Desktop (1024px and wider) has the rail and a padded main area; the
 * phone layout has the tab bar. Both are the same routes and the same data.
 */
export function AppShell() {
  const isDesktop = useDesktopMediaQuery();
  useLive();

  return (
    <LayoutContext.Provider value={isDesktop}>
      {isDesktop ? (
        <div className="flex h-dvh overflow-hidden bg-sand">
          <Rail />
          <main className="relative flex min-w-0 flex-1 flex-col px-7 py-6">
            <Outlet />
          </main>
        </div>
      ) : (
        <div className="flex h-dvh flex-col overflow-hidden bg-sand">
          <main className="relative flex min-h-0 flex-1 flex-col">
            <Outlet />
          </main>
          <BottomTabs />
        </div>
      )}
    </LayoutContext.Provider>
  );
}

/** Phone screens start below the status bar and keep 20px from the edges. */
export const PHONE_PAD = 'px-4 pt-[calc(env(safe-area-inset-top)+18px)]';
